import {
  catchError,
  combineLatest,
  filter,
  first,
  map,
  Observable,
  of,
  switchMap,
} from 'rxjs';

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthFacade } from '@ideapa/app-auth';

import { CheckBilanciFacade } from '../+state/check-bilanci.facade';

@Injectable()
export class CheckDatiRiepilogoModificatiGuard implements CanActivate {
  constructor(
    private facade: CheckBilanciFacade,
    private authFacade: AuthFacade
  ) {}
  canActivate(): Observable<boolean> {
    return this.checkLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkLoaded(): Observable<boolean> {
    return combineLatest([
      this.facade.riepilogoChecked$,
      this.facade.consolidatoEnteId$,
      this.facade.consolidatoAnno$,
      this.authFacade.ente$,
      this.authFacade.anno$,
    ]).pipe(
      map(([loaded, enteId, anno, loggedEnte, loggedAnno]) => {
        if (!loaded || enteId !== loggedEnte?.id || anno !== loggedAnno) {
          this.facade.checkDatiRiepilogoModificati();
        }
        return loaded;
      }),
      filter((loaded) => loaded),
      first()
    );
  }
}
